export const SAVE = 'LOCAL_STORAGE/SAVE';
export const SAVE_FAILURE = 'LOCAL_STORAGE/SAVE_FAILURE';
